import * as Sentry from "@sentry/react";
import {
	scrubbedBeforeBreadcrumb,
	scrubbedBeforeSend,
	scrubbedBeforeSendLog,
} from "./lib/phiScrub";

Sentry.init({
	dsn: "https://9bcc559c4844d42240ca195b111d83af@o4509068912558080.ingest.us.sentry.io/4510069921415168",
	// Environment: explicit var per deployment (staging | production). Falls
	// back to vite MODE for local dev (vite dev => "development", vite build
	// => "production"). VITE_SENTRY_ENVIRONMENT must be set in each Vercel
	// environment to distinguish staging from production builds (both of
	// which have MODE === "production").
	environment:
		import.meta.env.VITE_SENTRY_ENVIRONMENT ||
		import.meta.env.MODE ||
		"development",
	// HIPAA: D-11 — disable automatic PII collection (was true)
	sendDefaultPii: false,
	// Session Replay intentionally NOT enabled here — replay is owned by
	// PostHog (analytics + flags + replay) so we don't run it in two systems
	// (double bandwidth/perf cost). Sentry's scope here is errors, performance,
	// and structured logs only. Omitting replayIntegration also lets the
	// bundler tree-shake the replay code out.
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
	],
	beforeSend: scrubbedBeforeSend,
	beforeBreadcrumb: scrubbedBeforeBreadcrumb,
	enableLogs: true,
	beforeSendLog: scrubbedBeforeSendLog,
	tracesSampleRate: 0.1,
	tracePropagationTargets: [
		"localhost",
		/^\//,
		/^https:\/\/.*\.ngrok\.app/,
		// Exclude public CDN/static hosts to avoid CORS preflight failures from
		// Sentry's sentry-trace/baggage headers on unauthenticated asset fetches.
		// Keep propagation for Era API/application hosts only.
		/^https:\/\/(?!login-)(?!journeys-cdn\.)[\w-]+\.eraborn\.co/,
	],
});
